export default {
  loginBegin(state) {
    state.login = false;
    state.loading = true;
  },

  loginSuccess(state, accessToken) {
    state.accessToken = accessToken;
    state.loading = false;
    state.login = true;
  },

  loginErr(state, err) {
    state.loading = false;
    state.error = err;
  },

  logoutBegin(state) {
    state.loading = true;
  },

  logoutSuccess(state, data) {
    state.loading = false;
    state.login = data;
  },

  logoutErr(state, err) {
    state.loading = false;
    state.error = err;
  },
};
